<template>
<div>
    <div v-if="work">
         <div
                v-for="decision in work.decisions"
                :key="decision.id"
              >
                   <p> {{decision.answer}}</p>
                      <small> {{decision.comment}}</small>
             
              </div>
    </div>
</div>

</template>
<script>

export default {
  name: "text",
  props: {
    work: {
      default: null,
    },
  },
  data() {
    return {

    };
  },
};
</script>

